module.exports = __webpack_public_path__ + "static/media/p20-tip-box.c72db610.svg";